import { useEffect, useRef } from "react";

import { reportMissingEventMetadata } from "./inbox-adapter";

export type MissingEventMetadata = { eventType: string; itemId: string };

function toEventKey(event: MissingEventMetadata): string {
  return `${event.eventType}:${event.itemId}`;
}

export function useReportMissingEventMetadata(events: MissingEventMetadata[]): void {
  const reportedKeys = useRef<Set<string>>(new Set());

  useEffect(() => {
    for (const event of events) {
      const key = toEventKey(event);
      if (reportedKeys.current.has(key)) continue;
      reportedKeys.current.add(key);
      reportMissingEventMetadata(event.eventType, event.itemId);
    }
  }, [events]);
}
